import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { BACKEND_URL } from '../lib/backend';
import { LeadsCrm } from './admin/crm/LeadsCrm';

// Standalone CRM workspace for lead managers (admins can use it too).
export default function CrmPage() {
  const { user, token, logout, loading } = useAuth();
  const navigate = useNavigate();
  const [toast, setToast] = useState(null);
  const showToast = (type, message) => { setToast({ type, message }); setTimeout(() => setToast(null), 3500); };

  useEffect(() => {
    if (loading) return;
    if (!user) navigate('/login?next=/crm');
    else if (!['admin', 'lead_manager', 'collaborator'].includes(user.role)) navigate('/area-clienti');
  }, [user, loading, navigate]);

  if (!user || !['admin', 'lead_manager', 'collaborator'].includes(user.role)) return null;

  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="crm-page">
      <header className="sticky top-0 z-40 bg-slate-950/90 backdrop-blur border-b border-slate-800">
        <div className="max-w-[1600px] mx-auto px-6 h-14 flex items-center gap-4">
          <span className="text-amber-400 font-black tracking-tight">VocalFitness</span>
          <span className="text-xs uppercase tracking-[0.25em] text-slate-500">CRM</span>
          <span className="ml-auto text-sm text-slate-300" data-testid="crm-user-name">{user.full_name || user.username}</span>
          <button onClick={() => { logout(); navigate('/login'); }} className="text-slate-400 hover:text-white flex items-center gap-1 text-sm" data-testid="crm-logout-btn"><LogOut className="w-4 h-4" /> Esci</button>
        </div>
      </header>
      <main className="max-w-[1600px] mx-auto px-6 py-6">
        <LeadsCrm backendUrl={BACKEND_URL} token={token} showToast={showToast} currentUser={user} />
      </main>
      {toast && (
        <div className={`fixed top-20 right-4 z-[100] px-4 py-3 rounded-lg shadow-lg text-sm ${toast.type === 'success' ? 'bg-emerald-600' : 'bg-rose-600'}`} data-testid="crm-toast">{toast.message}</div>
      )}
    </div>
  );
}
